import type { CSSProperties } from 'react';

export const HoverSlotStyles: CSSProperties = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  textAlign: 'center',
};
